module.exports = __webpack_public_path__ + "img/conference-image-2-graded.91aafee8.jpg";